import {action, observable, runInAction} from 'mobx';
import request from '../utils/request';
import {category, events} from "../constants/enums";
import {notebookThemes} from "../constants/constants";
import {customEvent} from "../utils/analyticsUtil";
import {getUserProperties, setUserAvatar} from '../utils/userUtility';
import {isStudent} from '../utils/userUtility'
import manageStore from './ManageStore';
import {MANAGE_STUDENT} from '../constants/urlConstants';

class TimelineManageStore {
    @observable activeTheme = notebookThemes[0];
    @observable tempAvatar = null

    @action clearAvatar = () => {
        this.tempAvatar = null
    }

    @action setTheme = (studentTheme) => {
        if (isStudent()) {
            const theme = getUserProperties().theme
            this.activeTheme = notebookThemes.find(i => i.theme === theme) || notebookThemes[0]
        } else {
            if (!studentTheme) {
                this.activeTheme = notebookThemes[0]
            } else {
                this.activeTheme = {theme: studentTheme}
            }
        }
    }

    @action changeTheme = async (theme, studentId) => {
        this.activeTheme = {theme: theme}
        try {
            await request(`${MANAGE_STUDENT}/${studentId}/theme`, {method: 'POST', body: {theme: theme, studentId: studentId}});
            runInAction(() => {
                manageStore.updateStudentTheme(studentId, theme)
            });
        } catch (error) {
            console.log(error)
        }
        customEvent(events.CustomEvent, {category: category.ChangeTheme, action: theme});
    }

    @action changeAvatar = async (avatar, studentId) => {
        if (isStudent()) {
            setUserAvatar(avatar)
        } else {
            this.tempAvatar = avatar
            try {
                await request(`${MANAGE_STUDENT}/${studentId}/avatar`, {method: 'POST', body: {avatar: avatar, studentId: studentId}});
            } catch (error) {
                console.log(error)
            }
        }
        customEvent(events.CustomEvent, {category: category.ChangeAvatar});
    }
}

const timelineManageStore = new TimelineManageStore();
export default timelineManageStore;

